module.exports = __webpack_public_path__ + "static/img/wp8_icons.7c946ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/images/wp8_icons.png
// module id = 1654
// module chunks = 28